export interface DataCollectionRecord {
  [key: string]: any
}

export const assetsId = 'assets'
export const profilesId = 'profiles'
export const companiesId = 'companies'
